import { URLS } from '@/data';
import { useUserStore } from '@/hooks/use-user-store';
import { useQuery } from '@tanstack/react-query';

export type MatchPreviewResponse = {
    headline: string;
    items: string[];
};

const fetchMatchPreview = async (eventId: string): Promise<MatchPreviewResponse> => {
    const response = await fetch(`${URLS.FANTASY_AI_SERVICE_URL}/generate-match-preview`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: useUserStore.getState().session?.access_token ?? '',
        },
        body: JSON.stringify({ eventId }),
    });
    const data = await response.json();
    if (!response.ok) {
        throw data;
    }
    return data;
};

export const useMatchPreview = ({ eventId, enabled }: { eventId: string; enabled: boolean }) => {
    return useQuery({
        queryKey: ['match-ai-preview', eventId],
        queryFn: () => fetchMatchPreview(eventId),
        staleTime: 60 * 60 * 1000, // 1 hour
        enabled,
    });
};
